/**
 * WARNING: this file is automatically generated with the 'make codegen' command.
 * Any manual changes will be overwritten.
*/
import { studentPortalApiBase as api } from '../studentPortalApiBase';
export const addTagTypes = [
  'Events',
  'Students',
  'Reminders',
  'Misc',
  'Feedback',
  'Courses',
  'Notifications',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      listStudentEvents: build.query<
        ListStudentEventsApiResponse,
        ListStudentEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/events/timetable/student`,
          params: {
            weekStart: queryArg.weekStart,
            networkId: queryArg.networkId,
          },
        }),
        providesTags: ['Events'],
      }),
      listStudentEventsIcs: build.query<
        ListStudentEventsIcsApiResponse,
        ListStudentEventsIcsApiArg
      >({
        query: (queryArg) => ({
          url: `/events/timetable/student/ics`,
          params: { t: queryArg.t },
        }),
        providesTags: ['Events'],
      }),
      listStudents: build.query<ListStudentsApiResponse, ListStudentsApiArg>({
        query: (queryArg) => ({
          url: `/students`,
          params: { continuationToken: queryArg.continuationToken },
        }),
        providesTags: ['Students'],
      }),
      getStudent: build.query<GetStudentApiResponse, GetStudentApiArg>({
        query: (queryArg) => ({ url: `/students/${queryArg.studentId}` }),
        providesTags: ['Students'],
      }),
      getOwnReminder: build.query<
        GetOwnReminderApiResponse,
        GetOwnReminderApiArg
      >({
        query: (queryArg) => ({ url: `/reminders/me/${queryArg.eventId}` }),
        providesTags: ['Reminders'],
      }),
      addOwnReminder: build.mutation<
        AddOwnReminderApiResponse,
        AddOwnReminderApiArg
      >({
        query: (queryArg) => ({
          url: `/reminders/me/${queryArg.eventId}`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Reminders'],
      }),
      deleteOwnReminder: build.mutation<
        DeleteOwnReminderApiResponse,
        DeleteOwnReminderApiArg
      >({
        query: (queryArg) => ({
          url: `/reminders/me/${queryArg.eventId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Reminders'],
      }),
      ok: build.query<OkApiResponse, OkApiArg>({
        query: () => ({ url: `/health-probe` }),
        providesTags: ['Misc'],
      }),
      getFeaturebaseToken: build.query<
        GetFeaturebaseTokenApiResponse,
        GetFeaturebaseTokenApiArg
      >({
        query: () => ({ url: `/featurebase-token` }),
        providesTags: ['Feedback'],
      }),
      listCourseInstances: build.query<
        ListCourseInstancesApiResponse,
        ListCourseInstancesApiArg
      >({
        query: (queryArg) => ({
          url: `/course-instances`,
          params: {
            continuationToken: queryArg.continuationToken,
            courseId: queryArg.courseId,
            academicYear: queryArg.academicYear,
          },
        }),
        providesTags: ['Courses'],
      }),
      updateCourseInstances: build.mutation<
        UpdateCourseInstancesApiResponse,
        UpdateCourseInstancesApiArg
      >({
        query: (queryArg) => ({
          url: `/course-instances`,
          method: 'PATCH',
          body: queryArg.body,
          params: { academicYear: queryArg.academicYear },
        }),
        invalidatesTags: ['Courses'],
      }),
      getCourseInstance: build.query<
        GetCourseInstanceApiResponse,
        GetCourseInstanceApiArg
      >({
        query: (queryArg) => ({
          url: `/course-instances/${queryArg.courseInstanceId}`,
          params: { academicYear: queryArg.academicYear },
        }),
        providesTags: ['Courses'],
      }),
      getCourseTimetable: build.query<
        GetCourseTimetableApiResponse,
        GetCourseTimetableApiArg
      >({
        query: (queryArg) => ({
          url: `/events/timetable/course`,
          params: {
            courseId: queryArg.courseId,
            courseYear: queryArg.courseYear,
            weekStart: queryArg.weekStart,
            format: queryArg.format,
          },
        }),
        providesTags: ['Events'],
      }),
      listCourses: build.query<ListCoursesApiResponse, ListCoursesApiArg>({
        query: (queryArg) => ({
          url: `/courses`,
          params: { academicYear: queryArg.academicYear },
        }),
        providesTags: ['Courses'],
      }),
      updateCourses: build.mutation<
        UpdateCoursesApiResponse,
        UpdateCoursesApiArg
      >({
        query: (queryArg) => ({
          url: `/courses`,
          method: 'PATCH',
          body: queryArg.body,
          params: { academicYear: queryArg.academicYear },
        }),
        invalidatesTags: ['Courses'],
      }),
      getCourse: build.query<GetCourseApiResponse, GetCourseApiArg>({
        query: (queryArg) => ({
          url: `/courses/${queryArg.courseId}`,
          params: { academicYear: queryArg.academicYear },
        }),
        providesTags: ['Courses'],
      }),
      getApiToken: build.query<GetApiTokenApiResponse, GetApiTokenApiArg>({
        query: () => ({ url: `/token` }),
        providesTags: ['Misc'],
      }),
      listSuggestableEvents: build.query<
        ListSuggestableEventsApiResponse,
        ListSuggestableEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/events/suggestable`,
          params: { from: queryArg['from'], to: queryArg.to },
        }),
        providesTags: ['Events'],
      }),
      listNotifications: build.query<
        ListNotificationsApiResponse,
        ListNotificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications`,
          params: {
            continuationToken: queryArg.continuationToken,
            networkId: queryArg.networkId,
          },
        }),
        providesTags: ['Notifications'],
      }),
      listUnreadNotifications: build.query<
        ListUnreadNotificationsApiResponse,
        ListUnreadNotificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/unread`,
          params: {
            continuationToken: queryArg.continuationToken,
            networkId: queryArg.networkId,
          },
        }),
        providesTags: ['Notifications'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as studentPortalApi };
export type ListStudentEventsApiResponse = /** status 200 Ok */ {
  events: any[];
  timetable:
    | {
        redirectTo?: any;
        isCurrentAvailable?: any;
        nextCourseYear?: any;
        nextCourseId?: any;
        courseYear: any;
        courseId: string;
        courseName: string;
        studentName: string;
        published: boolean;
      }
    | {
        redirectTo: {
          courseYear: number;
          courseId: string;
        };
        isCurrentAvailable: boolean;
        nextCourseYear: number;
        nextCourseId: string;
        courseYear: number;
        courseId: string;
        courseName: string;
        studentName: string;
        published: boolean;
      };
  registered: boolean;
};
export type ListStudentEventsApiArg = {
  /** The start of the week for the timetable */
  weekStart: string;
  /** The network ID of the student (admin only) */
  networkId?: string;
};
export type ListStudentEventsIcsApiResponse = unknown;
export type ListStudentEventsIcsApiArg = {
  /** The token */
  t: string;
};
export type ListStudentsApiResponse = /** status 200 Ok */ {
  continuationToken?: string;
  data: Student[];
};
export type ListStudentsApiArg = {
  /** The continuation token */
  continuationToken?: string;
};
export type GetStudentApiResponse = /** status 200 Ok */ Student;
export type GetStudentApiArg = {
  /** The student ID */
  studentId: string;
};
export type GetOwnReminderApiResponse = /** status 200 Ok */ Reminder;
export type GetOwnReminderApiArg = {
  eventId: string;
};
export type AddOwnReminderApiResponse = /** status 201 Created */ Reminder;
export type AddOwnReminderApiArg = {
  eventId: string;
  body: {
    eventType: ReminderEventType;
  };
};
export type DeleteOwnReminderApiResponse = unknown;
export type DeleteOwnReminderApiArg = {
  eventId: string;
};
export type OkApiResponse = /** status 200 Ok */ {
  status: string;
};
export type OkApiArg = void;
export type GetFeaturebaseTokenApiResponse = /** status 200 Ok */ string;
export type GetFeaturebaseTokenApiArg = void;
export type ListCourseInstancesApiResponse = /** status 200 Ok */ {
  continuationToken: string;
  data: CourseInstance[];
};
export type ListCourseInstancesApiArg = {
  /** The continuation token for pagination */
  continuationToken?: string;
  /** An optional course ID to filter by */
  courseId?: string;
  /** The academic year of the course */
  academicYear?: string;
};
export type UpdateCourseInstancesApiResponse = unknown;
export type UpdateCourseInstancesApiArg = {
  /** The academic year of the course */
  academicYear: string;
  /** Course instances to update */
  body: {
    academicYear: string;
    publishedBy?: string;
    publishedDate?: string;
    willNotPublish?: boolean;
    published?: boolean;
    year: number;
    courseName: string;
    courseId: string;
    id: string;
  }[];
};
export type GetCourseInstanceApiResponse = /** status 200 Ok */ CourseInstance;
export type GetCourseInstanceApiArg = {
  /** The unique identifier for the course instance */
  courseInstanceId: string;
  /** The academic year of the course */
  academicYear?: string;
};
export type GetCourseTimetableApiResponse = /** status 200 Ok */
  | TimetableEvent[]
  | string;
export type GetCourseTimetableApiArg = {
  /** The ID of the course */
  courseId: string;
  /** The year of the course */
  courseYear: string;
  /** The start of the week for the timetable */
  weekStart?: string;
  /** The format of the response, JSON or ICS */
  format?: string;
};
export type ListCoursesApiResponse =
  /** status 200 A list of courses filtered by the provided academic year */ Course[];
export type ListCoursesApiArg = {
  /** The academic year to filter the courses by */
  academicYear?: string;
};
export type UpdateCoursesApiResponse = unknown;
export type UpdateCoursesApiArg = {
  /** The academic year of the courses */
  academicYear: string;
  /** Courses to update */
  body: (PickCourseId & PartialCourse)[];
};
export type GetCourseApiResponse =
  /** status 200 A single course with instances for the specified academic year */ CourseWithInstances;
export type GetCourseApiArg = {
  /** The unique identifier for the course */
  courseId: string;
  /** The academic year to filter the course instances by */
  academicYear?: string;
};
export type GetApiTokenApiResponse = /** status 200 Ok */ ApiToken;
export type GetApiTokenApiArg = void;
export type ListSuggestableEventsApiResponse =
  /** status 200 Ok */ SuggestableEvent[];
export type ListSuggestableEventsApiArg = {
  from?: string;
  to?: string;
};
export type ListNotificationsApiResponse = /** status 200 Ok */ {
  continuationToken?: string;
  data: Notification[];
};
export type ListNotificationsApiArg = {
  /** The continuation token */
  continuationToken?: string;
  /** The networkId of a specific user to receive notifications for */
  networkId?: string;
};
export type ListUnreadNotificationsApiResponse = /** status 200 Ok */ {
  continuationToken?: string;
  data: Notification[];
};
export type ListUnreadNotificationsApiArg = {
  /** The continuation token */
  continuationToken?: string;
  /** The networkId of a specific user to receive notifications for */
  networkId?: string;
};
export type Student = {
  networkId: string;
  studentId: string;
  studentName: string;
  studentEmail: string;
  courseName: string;
  courseId: string;
  courseYear: number;
  nextCourseId?: string;
  nextCourseYear?: number;
};
export type ReminderEventType = 'suggestable' | 'timetable';
export type Reminder = {
  id: string;
  reminderTime: string;
  eventType: ReminderEventType;
  eventId: string;
  userId: string;
};
export type CourseInstance = {
  academicYear: string;
  id: string;
  published: boolean;
  publishedDate?: string;
  publishedBy?: string;
  willNotPublish: boolean;
  courseId: string;
  courseName: string;
  year: number;
};
export type TimetableEvent = {
  id: string;
  /** The main label/name of the event
    line breaks are allowed and should be respected when rendering */
  name: string;
  /** ISO8601 */
  startTime: string;
  /** ISO8601 */
  finishTime: string;
  /** arbitrary string representing the location of the event,
    doesn't have to be an address. */
  place?: string;
  /** whether the event has a fee/cost */
  paid?: boolean;
  /** the price of the event in pence, if it has a fee */
  price?: number;
  /** a parseable address/postcode of the event */
  location?: string;
  /** arbitrary string describing the "type" of event (e.g. "lecture") */
  type: string;
  /** description of the event */
  description?: string;
  /** an external URL to a page with more information about the event */
  externalLink?: string;
  /** optional URL to an image representing the event */
  photoUrl?: string;
  academicYear: string;
  courseYear: number;
  moduleNames: string[];
  roomNames: string[];
  courseId: string;
  lecturerNames: string[];
  moduleGroups: string[];
  isTimetableEvent: true;
};
export type Course = {
  academicYear: string;
  id: string;
  published: boolean;
  publishedDate?: string;
  publishedBy?: string;
  willNotPublish: boolean;
  name: string;
  numYears: number;
};
export type PickCourseId = {
  id: string;
};
export type PartialCourse = {
  name?: string;
  numYears?: number;
  academicYear?: string;
  id?: string;
  published?: boolean;
  publishedDate?: string;
  publishedBy?: string;
  willNotPublish?: boolean;
};
export type CourseWithInstances = {
  academicYear: string;
  id: string;
  published: boolean;
  publishedDate?: string;
  publishedBy?: string;
  willNotPublish: boolean;
  name: string;
  numYears: number;
  instances: CourseInstance[];
};
export type UserId = string;
export type ApiToken = {
  userId: UserId;
  networkId: string;
  value: string;
  created: string;
};
export type SuggestableEventSource = 'native.fm' | 'sharepoint';
export type SuggestableEvent = {
  id: string;
  /** The main label/name of the event
    line breaks are allowed and should be respected when rendering */
  name: string;
  /** ISO8601 */
  startTime: string;
  /** ISO8601 */
  finishTime: string;
  /** arbitrary string representing the location of the event,
    doesn't have to be an address. */
  place?: string;
  /** whether the event has a fee/cost */
  paid?: boolean;
  /** the price of the event in pence, if it has a fee */
  price?: number;
  /** a parseable address/postcode of the event */
  location?: string;
  /** arbitrary string describing the "type" of event (e.g. "lecture") */
  type: string;
  /** description of the event */
  description?: string;
  /** an external URL to a page with more information about the event */
  externalLink?: string;
  /** optional URL to an image representing the event */
  photoUrl?: string;
  /** keywords that can be used to categorize this event */
  tags: string[];
  /** standardised categories */
  categories: string[];
  /** the source of the event */
  source: SuggestableEventSource;
};
export type Notification = {
  /** A GUID unique to the notification */
  id: string;
  createDate: string;
  updateDate: string;
  /** Student/Recipient's NetworkID */
  networkId: string;
  /** The name of the category that the notification relates to (e.g. "Marketing") */
  categoryName: string;
  /** Whether the notification is returned from the "listUnreadNotifications" endpoint */
  showInApp: boolean;
  /** Whether delivery of the notification should be attempted by the email channel */
  tryEmail: boolean;
  /** Whether delivery of the notification should be attempted by the push channel */
  tryPush: boolean;
  /** Deep link to navigate the user to when they click the notification in their OS or in app */
  link?: string;
  /** URL to an icon to display against the notification */
  iconUrl?: string;
  /** Date/time the notification was seen by the user */
  inAppSeenAt?: string | boolean;
  /** Title for the notification when viewed within the app (distinct from pushTitle below) */
  inAppTitle?: string;
  /** Description/body text for the notification when viewed within the app (distinct from pushContent below) */
  inAppContent?: string;
  /** Subject line for the notification when delivered by email */
  emailSubject?: string;
  /** Body (supports HTML) content for the notification when delivered by email */
  emailContent?: string;
  /** Title for the notification when viewed in the OS notification drawer */
  pushTitle?: string;
  /** Description/body text for the notification when viewed in the OS notification drawer */
  pushContent?: string;
  /** General title - copied to delivery-specific title field if the relevant channel is enabled and a specific delivery channel field is empty */
  title: string;
  /** General description/body - copied to delivery-specific content field if the relevant channel is enabled and specific delivery channel field is empty */
  content: string;
};
export const {
  useListStudentEventsQuery,
  useListStudentEventsIcsQuery,
  useListStudentsQuery,
  useGetStudentQuery,
  useGetOwnReminderQuery,
  useAddOwnReminderMutation,
  useDeleteOwnReminderMutation,
  useOkQuery,
  useGetFeaturebaseTokenQuery,
  useListCourseInstancesQuery,
  useUpdateCourseInstancesMutation,
  useGetCourseInstanceQuery,
  useGetCourseTimetableQuery,
  useListCoursesQuery,
  useUpdateCoursesMutation,
  useGetCourseQuery,
  useGetApiTokenQuery,
  useListSuggestableEventsQuery,
  useListNotificationsQuery,
  useListUnreadNotificationsQuery,
} = injectedRtkApi;
